// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "@media(max-width: 426px){.template-btn[data-v-6d4001d4]{margin-top:5px}}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/message/components/MessageTemplateNewDialog.vue"],"names":[],"mappings":"AAEC,yBADD,+BAEE,cAAA,CAAA","file":"MessageTemplateNewDialog.vue","sourcesContent":["\n.template-btn {\n\t@media (max-width: 426px) {\n\t\tmargin-top: 5px;\n\t}\n}\n"]}]);
// Exports
module.exports = exports;
